@if (ready) {
  <se-fe-header
    class="persona-avatar"
    [seFeDataTitle]="!headerLink && title"
    [seFeDataTitleTruncate]="true"
    [seFeDataSubtitle]="!subtitleLink && subtitle"
    [seFeDataLevel]="0"
    [seFeDataSize]="headerDataSize">
    <se-fe-avatar
      seFeHeaderVisual
      seFeDataType="persona"
      [seFeDataIdentity]="title"
      [seFeDataImgUrl]="imageUrl"
      [seFeDataSize]="avatarDataSize">
    </se-fe-avatar>
    @if (headerLink) {
      <a seFeHeaderTitle class="persona-avatar-link" [href]="headerLink">{{ title }}</a>
    }
    @if (subtitleLink) {
      <a seFeHeaderSubtitle seFeLink="low" [href]="subtitleLink">{{ subtitle }}</a>
    }
    <ng-content seFeHeaderActions select="[personaAvatarActions]"></ng-content>
  </se-fe-header>
}
